import TabPage from "./../factories/tab-page";
import "./../bindings/bao-upload";
import BaseViewModel from "./../factories/base-view-model";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
class ImportServiceComponent extends BaseViewModel {
    OutputPath = ko.observable();
    FileName = ko.observable();
    NewsJobId = ko.observable();
    MailAdress = ko.observable();
    JobFileId = ko.observable();
    Loading = ko.observable<boolean>(false);
    LoadUrl = ko.computed(function () {
        return "ImportServiceComponent/UploadTemplate/?newsJobId=" + this.NewsJobId();
    }, this);
    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.TabPage = tabPage;
    }
    Refresh() {
        this.TabPage.IsLoading(true);
        return Bao.post("ImportServiceComponent/Get", JSON.stringify({}), (result) => {
            if (result != null) {
            }
            this.TabPage.IsLoading(false);
        });
    }
    ImportAndStartJob() {
        this.TabPage.IsLoading(true);
        this.UploadTemplate().then((result) => {
            if (result == null) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUploadFailed"), "info");
                this.Loading(false);
                this.TabPage.IsLoading(false);
            }
            else {
                this.JobFileId(result);
                return Bao.post("ImportServiceComponent/ImportDocumentAndStartJob", JSON.stringify({
                    jobFileId: this.JobFileId(),
                    mailAdress: this.MailAdress(),
                }), (result) => {
                    if (result == "True") {
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUploadCompleted"), "info");
                    }
                    else {
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUploadFailed"), "info");
                    }
                    this.TabPage.IsLoading(false);
                });
            }
        });
    }
    UploadTemplate(): JQueryPromise<any> {
        // dummy
        return null;
    }
    loaded() {
        return Bao.Session.GetMessage("msgNewImportServiceComponent").then((result) => {
            this.TabPage.Title(result);
        }).then(() => {
            return Bao.post("ImportServiceComponent/SetDefaults", JSON.stringify({}), (result) => {
                if (result != null) {
                    this.MailAdress(result.mail);
                }
                this.TabPage.IsLoading(false);
            }).then(() => {
                return this.Refresh();
            });
        });
    }
    ;
}
export default ImportServiceComponent;